
      const id = import.meta.env.VITE_KLAVIYO_PUBLIC_KEY || "";
      if (!id) {
        console.warn("[Klaviyo] VITE_KLAVIYO_PUBLIC_KEY ontbreekt");
      } else {
        // set account + laad script dynamisch
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(["account", id]);

        const s = document.createElement("script");
        s.defer = true;
        s.src = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${id}`;
        document.head.appendChild(s);
      }
    